export const tagCloudFetchCount = 200;
export const tagCloudSingleLimit = 200;
export const tagCloudCompareLimit = 100;
